import updateExpressionPage from './updateExpressionPage';
import saveEmojiSkinToneToServer from '../actions/saveEmojiSkinToneToServer';
import updateSearch from '../actions/updateSearch';
import ExpressionPage from '../store/schema/ExpressionPage';
import ExpressionPickerViewState from '../store/schema/ExpressionPickerViewState';
import expressionStore from 'owa-expressions-store/lib/store/expressionStore';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';
import { action } from 'satcheljs/lib/legacy';

export default action('resetExpressionPickerViewState')(function resetExpressionPickerViewState() {
    const viewState: ExpressionPickerViewState = expressionStore.expressionPickerViewState;

    if (viewState.searchTerm) {
        updateSearch(viewState, '');
    }

    updateExpressionPage(viewState, ExpressionPage.All.toString());
    if (!isBrowserIE()) {
        saveEmojiSkinToneToServer(true);
    }
    viewState.isOpen = false;
});
